// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TCompleteAuthRequest,
  TLoginPayload,
  IAuthModel,
  TCompleteAuthResponse,
} from '~/misc/auth/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerAuthModel extends ManagerResource implements IAuthModel {
  complete(
    payload: TCompleteAuthRequest,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TCompleteAuthResponse> {
    return this.post<TCompleteAuthResponse>('login/process', payload, requestConfig);
  }

  login(payload: TLoginPayload, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.post<void>('login/request', payload, requestConfig);
  }

  logout(): Promise<void> {
    return this.post<void>('logout');
  }
}
